/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cool_Wise_Cow_KnitInputs */

const en_cool_wise_cow_knit = /** @type {(inputs: Cool_Wise_Cow_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only self created`)
};

const de_cool_wise_cow_knit = /** @type {(inputs: Cool_Wise_Cow_KnitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur selbst erstellte`)
};

/**
* | output |
* | --- |
* | "Only self created" |
*
* @param {Cool_Wise_Cow_KnitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cool_wise_cow_knit = /** @type {((inputs?: Cool_Wise_Cow_KnitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cool_Wise_Cow_KnitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cool_wise_cow_knit(inputs)
	return de_cool_wise_cow_knit(inputs)
});